import Typography from 'components/global/Typography';

const CurrencyViewer = ({ data, value, renderCellProps }) => (
	<Typography withCurrency currency={data[renderCellProps?.currency ?? 'currency']}>
		{value}
	</Typography>
);

export default CurrencyViewer;
